import React from 'react';
import { useNavigate } from 'react-router-dom';
import StudyCompleteModalTemplate from '@component/iyagigo/modal/content-modal/study-complete-modal/study-complete-modal-template';
import TextBlock from '@component/common/block/text-block';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/modal-slice';
import { actions as navigationActions } from '@store/slice/navigation-slice';
import { createClipPath } from '@constant/iyagigo/route-path';
import * as color from '@constant/color';

const AuthenticExpressionCompleteModal: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  const handleReturnClick = () => {
    dispatch(modalActions.hideModal());
    dispatch(navigationActions.storeIyagigoSubMenu({ mainMenu: 'clip', subMenu: 'authentic-expression' }));
    navigate(createClipPath('home'));
  };

  return (
    <StudyCompleteModalTemplate
      title='생생표현 학습 완료'
      result={
        <TextBlock
          text='오늘의 표현을 잘 익혔어요'
          design={{ text: { size: 'small', color: color.GRAY_1 }, box: { alignX: 'center' } }}
        />
      }
      completedStepKey='isAuthenticExpressionCheck'
      serviceRoute={{ title: '생생표현으로 돌아가기', handleClick: handleReturnClick }}
    />
  );
};

export default AuthenticExpressionCompleteModal;
